import { on } from "events";
import { Check, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";

type AppCustomPropertyNumberProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyNumber = ({customProperty, data, validate, onChange} : AppCustomPropertyNumberProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, value);
    }, [value]);

    return (
        <div className="app-custom-property-number">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <input 
                    type="number"
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                        onChange(customProperty.label, event.target.value);
                    }}
                />
                {validate && !value && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                }
            </div>
        </div>
    )
}
